// extracted by mini-css-extract-plugin
export var body = "BoxNavigation-module--body--fIxCG";
export var component = "BoxNavigation-module--component--OmN2b";
export var header = "BoxNavigation-module--header--5QAWN";
export var item = "BoxNavigation-module--item--OA9pw";
export var link = "BoxNavigation-module--link--eGsY6";
export var list = "BoxNavigation-module--list--HuxvN";
export var preamble = "BoxNavigation-module--preamble--jyyuJ";